import { Pipe, PipeTransform } from '@angular/core';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'time'
})
export class TimePipe implements PipeTransform {
    transform(input: string): string {
        if (input === undefined) {
            return;
        }

        return `${input.split(':')[0]}:${input.split(':')[1]}`;

    }
}
